// File: src/components/FeatureList.tsx
import React from 'react';
import { List, ListItem, ListItemIcon, ListItemText } from '@mui/material';
import { useTranslation } from 'react-i18next';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';

const FeatureList = () => {
    const { t } = useTranslation();

    const features = [
        'features.ai_content_generation',
        'features.automated_analysis',
        'features.marketplace_adaptation',
        'features.simple_interface'
    ];

    return (
        <List sx={{ p: 0 }}>
            {features.map((translationKey, index) => (
                <ListItem
                    key={index}
                    sx={{
                        px: 0,
                        py: 1,
                        borderRadius: 1,
                        transition: 'all 0.3s ease-in-out',
                        '&:hover': {
                            backgroundColor: 'action.hover',
                            transform: 'translateX(8px)'
                        }
                    }}
                >
                    <ListItemIcon sx={{ minWidth: 32 }}>
                        <CheckCircleOutlineIcon
                            sx={{
                                color: 'primary.main',
                                fontSize: '1.2rem'
                            }}
                        />
                    </ListItemIcon>
                    <ListItemText
                        primary={t(translationKey)}
                        primaryTypographyProps={{
                            sx: {
                                color: 'text.primary',
                                fontSize: '0.95rem',
                                fontWeight: 500,
                                lineHeight: 1.3
                            }
                        }}
                    />
                </ListItem>
            ))}
        </List>
    );
};

export default FeatureList;
